import type { PoStatus, ProductStatus, RmaStatus } from "./api";

export const PRODUCT_STATUS_LABELS: Record<ProductStatus, string> = {
  active: "Active",
  discontinued: "Discontinued",
};

export const PO_STATUS_LABELS: Record<PoStatus, string> = {
  draft: "Draft",
  ordered: "Ordered",
  partially_received: "Partially received",
  received: "Received",
  cancelled: "Cancelled",
};

export const RMA_STATUS_LABELS: Record<RmaStatus, string> = {
  requested: "Requested",
  sent: "Sent",
  replaced: "Replaced",
  refunded: "Refunded",
  rejected: "Rejected",
  closed: "Closed",
};

type Tone = "muted" | "success" | "warning" | "danger";

export function poTone(status: PoStatus): Tone {
  switch (status) {
    case "received":
      return "success";
    case "ordered":
    case "partially_received":
      return "warning";
    case "cancelled":
      return "danger";
    default:
      return "muted";
  }
}

export function rmaTone(status: RmaStatus): Tone {
  switch (status) {
    case "replaced":
    case "refunded":
      return "success";
    case "sent":
    case "requested":
      return "warning";
    case "rejected":
      return "danger";
    default:
      return "muted";
  }
}

/** Which RMA statuses a record can transition to from its current one. */
export const RMA_NEXT: Record<RmaStatus, RmaStatus[]> = {
  requested: ["sent", "rejected"],
  sent: ["replaced", "refunded", "closed"],
  replaced: [],
  refunded: [],
  rejected: [],
  closed: [],
};
